<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<h2 mat-dialog-title cdkDragHandle>{{ title }}</h2>

<mat-dialog-content>
    <div class="center" *ngIf="isLoading | async">
        <mat-spinner></mat-spinner>
    </div>
    <cdk-virtual-scroll-viewport *ngIf="dataSource" itemSize="48" style="border: solid 1px #303030; min-height: 400px; height: auto;">
        <!-- <span *ngIf="filteredDatasource.length === 0" class="center" style="margin-top:90px; height: 100%; width: 100%; color: #888888">0 Folder found</span> -->
        <ng-container *cdkVirtualFor="let item of files"></ng-container>

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
                <!-- use a disabled button to provide padding for tree leaf -->
                <button mat-icon-button disabled></button>
                <mat-icon class="mat-icon-rtl-mirror" class="yellow-icon">folder</mat-icon>
                <button mat-button (click)="onFileSelected(node)">{{node.filename}}</button>
            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name" >
                    <mat-icon class="mat-icon-rtl-mirror">{{treeControl.isExpanded(node) ? 'expand_more' :
                        'chevron_right'}}</mat-icon>
                </button>
                <mat-icon class="mat-icon-rtl-mirror" class="yellow-icon" style="margin-right: 1px;padding-right: 1px;">
                    {{treeControl.isExpanded(node) ? 'folder_open' : 'folder'}}</mat-icon>
                <button mat-button (click)="onFileSelected(node)" style="margin-left: 1px;padding-left: 2px;text-align: left;">{{node.filename}}</button>
            </mat-tree-node>
        </mat-tree>
    </cdk-virtual-scroll-viewport>
    <!-- <div *ngIf="supportedFileTypes.length > 0" style="width: 100%; display: flex; justify-content: flex-end; margin-top: 10px;">
        <mat-form-field style="width: 140px">
            <mat-label>File(s) of type:</mat-label>
            <mat-select style="width: 100%" [(value)]="fileType" (selectionChange)="onFilterChanged($event)">
                <mat-option [value]="fileType" *ngFor="let fileType of supportedFileTypes">{{fileType}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div> -->
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-raised-button mat-dialog-close tabindex="-1">CLOSE</button>
</mat-dialog-actions>
</div>